// extracted by mini-css-extract-plugin
module.exports = {"TextOnImage":"TextOnImage_TextOnImage__iAOh4"};